import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Bell, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aimarketplace-18/artifacts/7akyhfla_IMG_5649.jpg';

export const Header = ({ title, showSearch = false }) => {
  const { user } = useAuth();

  return (
    <header className="glass sticky top-0 z-30 border-b border-border/50" data-testid="header">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Mobile logo */}
        <div className="flex items-center gap-3 lg:hidden">
          <Link to="/dashboard" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="Jambo" className="h-8 w-auto" />
          </Link>
        </div>

        {/* Desktop title */}
        <div className="hidden lg:block">
          <h1 className="text-2xl font-bold">{title || 'Dashboard'}</h1>
        </div>

        {/* Search */}
        {showSearch && (
          <div className="hidden md:flex flex-1 max-w-md mx-8">
            <div className="relative w-full">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input 
                placeholder="Search..." 
                className="pl-10 bg-muted/50 border-0"
                data-testid="search-input"
              />
            </div>
          </div>
        )}

        {/* Right actions */}
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" className="relative" data-testid="notifications-btn">
            <Bell className="h-5 w-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-orange-500 rounded-full" />
          </Button>
          
          <div className="hidden lg:flex items-center gap-2 ml-2 pl-4 border-l border-border">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-500 to-green-500 flex items-center justify-center">
              <span className="text-white font-semibold text-sm">
                {user?.name?.[0]?.toUpperCase() || 'U'}
              </span>
            </div>
            <span className="font-medium text-sm">{user?.name || 'User'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};
